import api from "@/modules/category/services/category";
import apiSousCat from "@/modules/category/services/sous_category"

const state = () => ({
    categories: [],
    categoriesSelect: [],
    sousCategorieSelect:[],
    apiRslt: {
        fetch: {
            inProgress: false,
            success: false,
            error: false,
        }
    },
    errorSousCatProduct:false
})

const getters = {
}

const actions = {
    loadSousCategories({ commit }) {
        apiSousCat.getSousCategories().then(result => {
            commit('SAVE_SOUS_CATEGORIES', result.data);
        }).catch(error => {
            throw new Error(`API ${error}`);
        });
    },
    loadCategories({commit}) {
        api.getCategories().then(result => {
            commit('SAVE_CATEGORY', result.data);
        }).catch(error => {
            throw new Error(`API ${error}`);
        });
    },
    loadCategoriesSelect({commit}) {
        api.getIRICategories().then(result => {
            commit('SAVE_CATEGORY_SELECT', result.data);
        }).catch(error => {
            throw new Error(`API ${error}`);
        });
    },
    addCategory ({ commit,dispatch }, newCategory) {
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        if (!newCategory) {
            return
        }
        api.postCategory(newCategory)
            .then((r) => {
                commit('SET_API_DATA_FETCH_SUCCESS',r.data)
                dispatch('notifications/postToChannel', {code: 'VALIDNOTIFICATION002', extra: 'catégorie' },{ root:true })
                commit('ADD_CATEGORY', r.data)
            })
            .catch((e) => {

                dispatch('notifications/postToChannel', {code: 'ERRNOTIFICATION002', extra: 'catégorie' },{ root:true })
                commit('SET_API_DATA_FETCH_ERROR', e)
            });
    },
    updateCategory({ commit, dispatch }, payload){
        commit('SET_API_DATA_FETCH_IN_PROGRESS')

        api.putCategory(payload.id, payload)
            .then((r) => {
                commit('SET_API_DATA_FETCH_SUCCESS',r.data)
                commit('UPDATE_CATEGORY', r.data);
                dispatch('notifications/postToChannel', {code: 'VALIDNOTIFICATION001', extra: 'catégorie' },{ root:true })
            })
            .catch((e) => {
                commit('SET_API_DATA_FETCH_ERROR', e)
                dispatch('notifications/postToChannel', {code: 'ERRNOTIFICATION001', extra: 'catégorie' },{ root:true })
            });
    },
    deleteCategory({ commit, dispatch }, id){
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        api.getCategory(id)
            .then((response) => {
                let hasProduct = false
                if(Array.isArray(response.data.products)){
                    if(response.data.products.length > 0) hasProduct = true
                }
                if(Array.isArray(response.data.sousCategory)){
                    response.data.sousCategory.map(x=>{
                        hasProduct = Array.isArray(x.product) && x.product.length > 0
                        if(hasProduct) hasProduct = true
                    })
                }
                if(hasProduct){
                    commit('SET_API_DATA_FETCH_SUCCESS',response.data)
                }
                commit('ERR_SOUS_CAT_PRODUCT',hasProduct) // set timeout
                setTimeout(() => {
                    commit('ERR_SOUS_CAT_PRODUCT',false)
                }, 3000);
                if(!hasProduct){
                    api.deleteCategory(id)
                        .then((r) => {
                            commit('SET_API_DATA_FETCH_SUCCESS',r.data)
                            commit('DELETE_CATEGORY',id)
                        })
                        .catch((e) => {
                            commit('SET_API_DATA_FETCH_ERROR', e)
                        })
                }
                dispatch('notifications/postToChannel', {code: 'VALIDNOTIFICATION003', extra: 'catégorie' },{ root:true })
            }).catch((e) => {
                commit('SET_API_DATA_FETCH_ERROR', e)
                dispatch('notifications/postToChannel', {code: 'ERRNOTIFICATION003', extra: 'catégorie' },{ root:true })
            })
    }
}

const mutations = {
    ERR_SOUS_CAT_PRODUCT(state,payload){
        state.errorSousCatProduct = payload
    },
    ADD_CATEGORY (state, category) {
        state.categories.push(category)
    },
    UPDATE_CATEGORY (state,payload){
        state.categories = state.categories.map(category => {
            if (category.id === payload.id) {
                return Object.assign({}, category, payload.data)
            }
            return category
        })
    },
    DELETE_CATEGORY (state, id){
        const index = state.categories.findIndex(c => c.id === id);
        state.categories.splice(index, 1);
    },
    SAVE_CATEGORY(state, categories) {
        state.categories = categories;
    },
    SAVE_CATEGORY_SELECT(state, categories) {
        state.categoriesSelect = categories;
    },
    SAVE_SOUS_CATEGORIES(state, sousCategorieSelect){
        state.sousCategorieSelect = sousCategorieSelect
    },

    // Result api
    SET_API_DATA_FETCH_IN_PROGRESS: (state) => {
        state.apiRslt.fetch.inProgress = true
        state.apiRslt.fetch.completed = false
        state.apiRslt.fetch.success = false
        state.apiRslt.fetch.error = false
    },
    SET_API_DATA_FETCH_SUCCESS: (state) => {
        state.apiRslt.fetch.inProgress = false
        state.apiRslt.fetch.completed = true
        state.apiRslt.fetch.success = true
        state.apiRslt.fetch.error = false
    },
    SET_API_DATA_FETCH_ERROR: (state) => {
        state.apiRslt.fetch.inProgress = false
        state.apiRslt.fetch.completed = true
        state.apiRslt.fetch.success = false
        state.apiRslt.fetch.error = true
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
